
import {
  apiGet,
  apiPut,
  apiDelete,
  apiPost,
  apiPatch,
  getCurrentUserId,
} from "../../../utils";

export const getAccountingDetailsAPI = (data) => {
  return apiGet("/api/accounting", data);
};

export const addAccountingDetailsAPI = (data) => {
  return apiPost("/api/accounting", data);
};

export const updateAccountingDetailsAPI = (params, data) => {
  return apiPut(`/api/accounting/${params.id}`, data);
};

export const deleteAccountingDetailsAPI = (id) => {
  return apiDelete(`/api/accounting/${id}`);
};

export const updateInvoiceDetailsAPI = (params, data) => {
  return apiPatch(`/api/invoice/updateInvoiceDetails/${params.id}`, data);
};

export const getPostedInvoiceByOrganizationIdAPI = (data) => {
  const { organizationId, offset, limit, sortBy, sortDirection } = data;
  return apiGet(`/api/invoice/getPostedInvoiceByOrganizationId/${organizationId}`, { offset, limit, sortBy, sortDirection });
};

export const getPostedInvoiceByUserIdAPI = (opsId) => {
  return apiGet(`/api/invoice/getInvoiceDetails/${opsId}`);
};